<template>
  <svg class="android-order-icon" :class="`android-order-icon--${size}`" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path :d="path" fill="currentColor" />
  </svg>
</template>

<script>
const PATHS = {
  address: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7Zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5Z',
  contact: 'M12 12c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5Zm0-8a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 10c-4.42 0-8 2.24-8 5v3h2v-3c0-1.54 2.68-3 6-3s6 1.46 6 3v3h2v-3c0-2.76-3.58-5-8-5Z',
  iphone: 'M17 1H7C5.9 1 5 1.9 5 3v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2Zm0 20H7V3h10v18Zm-3-1h-4v-1h4v1Z',
  date: 'M19 4h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2Zm0 16H5V9h14v11ZM5 7V6h14v1H5Z',
  currency: 'M3 5h18v14H3V5Zm2 2v10h14V7H5Zm7 1c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4Zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Z',
  plan: 'M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6Zm0 2.5L18.5 9H14V4.5ZM6 20V4h6v7h6v9H6Zm2-7h3v2H8v-2Zm0 4h8v2H8v-2Z',
  protect: 'M12 2 4 5v6c0 5.05 3.41 9.76 8 11 4.59-1.24 8-5.95 8-11V5l-8-3Zm0 3.12 5 1.88v4c0 3.75-2.39 7.29-5 8.42C9.39 18.29 7 14.75 7 11V7l5-1.88ZM10.6 14.6 8 12l1.4-1.4 1.2 1.19 3.99-3.99L16 9.2l-5.4 5.4Z',
  info: 'M11 17h2v-6h-2v6Zm1-15a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm-1-11h2V7h-2v2Z',
  radioChecked: 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm0-3a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z',
  copy: 'M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1Zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2Zm0 16H8V7h11v14Z',
  note: 'M9 2h6v2h3c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h3V2Zm0 4H6v14h12V6h-3v2H9V6Zm-1 5h8v2H8v-2Zm0 4h8v2H8v-2Z'
}

export default {
  name: 'AndroidOrderIcon',
  props: {
    name: {
      type: String,
      default: 'info'
    },
    size: {
      type: Number,
      default: 18
    }
  },
  computed: {
    path() {
      return PATHS[this.name] || PATHS.info
    }
  }
}
</script>

<style scoped>
.android-order-icon {
  display: block;
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
}

.android-order-icon--28 { width: 28px; height: 28px; flex-basis: 28px; }
.android-order-icon--30 { width: 30px; height: 30px; flex-basis: 30px; }
.android-order-icon--36 { width: 36px; height: 36px; flex-basis: 36px; }
</style>
